import store from '@/store/store'
import Component from 'vue-class-component'
import Vue from 'vue'
import { User } from '@/interfaces/IUser'

@Component
export class AppPage extends Vue {
	get isLoading() {
		return store.state.app.isLoading
	}

	isLoadingLocal = true
	isObfuscate = true

	setLocalLoading(status: boolean) {
		this.isLoadingLocal = status
	}

	get currentUser() {
		const { state } = this.$store
		return state.user as User.IUser
	}

	startLocalLoading() {
		this.isLoadingLocal = true
	}

	stopLocalLoading() {
		this.isLoadingLocal = false
	}

	toggleObfuscate() {
		this.isObfuscate = !this.isObfuscate
	}

	get isDataTableView() {
		const { state } = this.$store
		return state.app.isDataTableView
	}
}

export default AppPage
